module.exports = __webpack_public_path__ + "img/bell.64c7e0f1.png";